import styled from 'styled-components';

export const RightContainer = styled.div`
  float: right;
  margin-top: 20px;
  margin-right: 80px;
`;
